/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */

import styled from 'styled-components';
import Image from 'react-bootstrap/Image';
import { motion } from 'framer-motion';

export const ListContainer = styled(motion.div)`
  //   display: flex;
  cursor: pointer;
  justify-content: flex-start;
  align-items: center;
  margin: 1.2rem;
  @media (max-width: 480px) {
    display: flex;
    align-items: flex-start;
    margin: 1rem 0.2rem;
  }
  .toggle-menu {
    display: none;
    @media (max-width: 480px) {
      display: block;
    }
  }
  &:hover .toggle-menu {
    display: block;
  }
`;

export const IndexContainer = styled.div`
  @media (max-width: 480px) {
    display: none;
  }
`;

export const ItemImage: any = styled.div`
  width: 208px;
  height: 117px;
  @media (max-width: 480px) {
    width: 160px;
    height: auto;
  }
  // @media (min-width: 992px) {
  //    width:192px;
  //   height:108px;
  // }
  object-fit: contain;
  box-shadow: 2px 2px 5px #888888;
  border-radius: 0.5em;
  overflow: hidden;
  backdrop-filter: blur(50px);
  position: relative;
  background-color: rgba(255, 255, 255, 0.1);
  margin: 0;
  min-width: 0;
`;

export const ItemImagePlaceholder: any = styled(Image)`
  width: 208px;
  height: 117px;
  @media (max-width: 480px) {
    width: 160px;
    height: auto;
  }
  // @media (min-width: 992px) {
  //   width:192px;
  //   height:108px;
  // }
  object-fit: contain;
  max-width: 100%;
  max-height: 100%;
  margin: 0;
  text-align: center;
`;

export const ItemImageContainer: any = styled.div<{ backgroundImage: string }>`
  background-color: #ffffff;
  text-align: center;
  border-radius: 0.5em;
  width: 208px;
  height: 117px;
  @media (max-width: 480px) {
    width: 160px;
    height: auto;
    margin-left: 0.1em;
  }
  // @media (min-width: 992px) {
  //   width:192px;
  //   height:108px;
  // }
  margin: auto;
  background-image: ${(props) => {
    return `url(${props.backgroundImage})`;
  }};
`;
export const Title = styled.h6`
  font-size: 0.8em;
  line-height: 2em;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  @media (max-width: 480px) {
    font-size: 0.8em;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`;

export const Meta = styled.p`
  font-size: 0.7em;
  color: #8f8f8f;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  @media (max-width: 480px) {
    font-size: 0.7em;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`;

export const SpanContainer = styled.div`
  width: 208px;
  height: 117px;
  @media (max-width: 480px) {
    width: 160px;
    height: auto;
  }
  // @media (min-width: 992px and max-width:1080px) {
  //   width:192px;
  //   height:108px;
  // }
  display: flex;
`;

export const MetaLogo: any = styled(Image)`
  width: 20px;
  height: auto;
  border-radius: 10px;
  object-fit: contain;
  margin-top: -3px;
  padding: 1px;
`;

export const RightContainer = styled.div`
  height: 85vh;
  overflow: scroll;
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
  &::-webkit-scrollbar {
    display: none; /* for Chrome, Safari, and Opera */
  }
  @media (max-width: 480px) {
    height: auto;
  }
`;

export const ToggleContainer = styled.div`
  margin-left: auto;
  @media (max-width: 480px) {
    margin-left: 0;
    margin: auto;
  }
`;

export const HorizontalDivider = styled.hr`
  color: #8f8f8f;
  margin-left: 7rem;
`;

export const SectionDivider = styled.hr`
  color: #8f8f8f;
`;

export const SectionTitle = styled.h4`
  display:flex;
  justify-content:space-between;
  align-items:center
  font-weight: bold;
  padding:left:1rem;
  margin-left:1.5rem;
  font-size:1.0em;
  @media (max-width: 480px) {
    padding-left:0;
    margin-left:1rem;
    
  }
`;

export const ViewAllContainer = styled.span`
  font-size: 1.2rem;
  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const IconImage: any = styled(Image)`
  position: absolute;
  right: 1.4rem;
  bottom: 50%;
`;
export const SeeAll: any = styled.a`
  font-size: 0.8em;
  font-weight: bold;
`;
